import React from "react";
import contextProvider from "../../contextProvider";
import { withRouter } from "react-router-dom";
import classnames from "classnames";
import _ReactOBaseComponent from "../../_L0_components/_ReactOBaseComponent";
import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import ReactOModal from "../../_L1_components/Elements/ReactOModal";
import { _LoadingWrapper } from "../../_L0_components/Widgets/_LoadingKit";
import ReactOButton from "../../_L1_components/Elements/ReactOButton";
import {
  ResponsiveContainer,
  ComposedChart,
  Tooltip,
  XAxis,
  YAxis,
  Area,
  Line,
} from "recharts";
// import { Row, Col, ButtonGroup, Badge, ListGroup, ListGroupItem } from "reactstrap";

class ApCoverageTable extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: {},
      _collapse_controllers: {},
      chartData: {},
    };
    super(props, initState);
    this.apiStore = null;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  cleanKey(key, replace) {
    const data = key.split(replace);
    if (data.length == 1) {
      return key;
    } else {
      return data[0];
    }
  }

  onComponentDidMount() {
    this.apiStore = this.getAppContext().getApiStoreService();
    // this.sort();
  }

  loadChartData(options) {
    // FORMAT FREQ OBJ
    let wifi_data_obj = {};
    Object.keys(this.props.wifi_data).map((freqVal) => {
      wifi_data_obj[freqVal] = {};
      return Object.keys(this.props.wifi_data[freqVal]).map((freq) => {
        if (this.props.wifi_data[freqVal][freq].ord != -1) {
          let newData = this.props.wifi_data[freqVal][freq];
          newData.freq = freq;
          wifi_data_obj[freqVal][this.props.wifi_data[freqVal][freq].ord] = newData;
        }
        return wifi_data_obj;
      });
    });

    this.setState({ loading: true }, () => {
      this.apiStore.fire("apcoverage", {
        data: {
          probeid: this.props.match.params.probeuid,
          essid: options.essid,
          bssid: options.bssid,
          ap_name: options.ap_name,
          command: options.command,
          from_ts: options.from_ts,
          to_ts: options.to_ts,
        },
        ___onSuccess: (status, response_data) => {
          let _initFreq = Object.keys(response_data.graphs[options.ap_name]).sort()[0];
          this.setState({
            loading: false,
            // chartData: response_data,
            freq: _initFreq,
            ap_name: options.ap_name,
            essid: options.essid,
            WIFIDATA: wifi_data_obj,
          });
          this._chart_modal.open(response_data);
        },
        ___onError: (error, data) => {
          this.setState(
            {
              loading: false,
            },
            () => {
              console.error(error);
            }
          );
        },
      });
    });
  }

  onComponentWillUnmount() {}

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <div>
          {this.getAppContext().media.isMobile ? (
            (() => {
              let k = 0;
              return Object.keys(this.props.coverageList).map((a, id) => {
                return Object.keys(this.props.coverageList[a]).map((apname, id2) => {
                  return Object.values(this.props.coverageList[a][apname]).map(
                    (b, id3) => {
                      return Object.values(b).map((essid, id4) => {
                        return Object.keys(essid).map((content, id5) => {
                          k += 1;
                          return (
                            <div
                              key={id5}
                              className={k % 2 == 0 ? "row-stripe-table p-2" : "p-2"}
                            >
                              <div className="ml-2">
                                <strong className="sub-title">AP: </strong>
                                {apname}
                              </div>
                              <div className="ml-2">
                                <strong className="sub-title">ESSID: </strong>
                                {essid[content].essid}
                              </div>
                              <div className="ml-2">
                                <strong className="sub-title">MAC: </strong>
                                {essid[content].bssid}
                              </div>
                              <div className="ml-2">
                                <strong className="sub-title">FREQ: </strong>
                                {essid[content].freq + " MHz"}
                              </div>
                              <div className="ml-2">
                                <strong className="sub-title">RSSI: </strong>
                                <span
                                  className={classnames({
                                    "text-success":
                                      parseInt("-" + essid[content].rssi) >= -60,
                                    "text-orange":
                                      parseInt("-" + essid[content].rssi) >= -74 &&
                                      parseInt("-" + essid[content].rssi) < -60,
                                    "text-danger":
                                      parseInt("-" + essid[content].rssi) < -74,
                                  })}
                                >
                                  {"-" + essid[content].rssi + " dBm"}
                                </span>
                              </div>
                              <div className="ml-2">
                                <strong className="sub-title">PRESENCE: </strong>
                                {essid[content].perc == "100.00"
                                  ? "100 %"
                                  : essid[content].perc + " %"}
                              </div>
                            </div>
                          );
                        });
                      });
                    }
                  );
                });
              });
            })()
          ) : (
            <div className="d-flex">
              <div className="flex-grow-1 table-responsive-xl">
                <table className="table">
                  <thead className="thead-light">
                    <tr>
                      {this.props.cols.map((_th, id) => {
                        return (
                          <th
                            key={_th.data_key}
                            scope="col"
                            className="text-nowrap text-muted dividers px-2 py-1"
                            style={{ width: _th.width + "%" }}
                          >
                            <div className={"d-flex justify-content-" + _th.align}>
                              <small className="">
                                <strong>
                                  {_th.icon && <span className={_th.icon + " mr-1"} />}
                                  {_th.title}
                                </strong>
                              </small>
                            </div>
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {this.props.coverageList && this.props.rowSpan && this.props.rowClass
                      ? Object.keys(this.props.coverageList).map((a, id) => {
                          return Object.keys(this.props.coverageList[a]).map(
                            (apname, id2) => {
                              return Object.values(
                                this.props.coverageList[a][apname]
                              ).map((b, id3) => {
                                return Object.values(b).map((essid, id4) => {
                                  return Object.keys(essid).map((content, id5) => {
                                    const parsedEssid = this.cleanKey(
                                      essid[content].essid,
                                      "#"
                                    );
                                    return (
                                      <tr
                                        key={id + id2 + +id4 + id5 + id3}
                                        className={this.props.rowClass[apname]}
                                      >
                                        {id3 == 0 && id5 == 0 ? (
                                          <td
                                            className="border-right align-middle text-center"
                                            rowSpan={this.props.rowSpan[apname]}
                                          >
                                            <strong>
                                              {this.props.rogue != true ? apname : ""}
                                            </strong>
                                          </td>
                                        ) : null}
                                        {id5 == 0 ? (
                                          <td
                                            className="border-right align-middle text-center"
                                            rowSpan={Object.keys(essid).length}
                                            title="View chart"
                                          >
                                            <div
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) => {
                                                e.preventDefault();
                                                this.loadChartData({
                                                  command: "essid",
                                                  from_ts: this.props.from_ts,
                                                  to_ts: this.props.to_ts,
                                                  essid: parsedEssid || "",
                                                  bssid: essid[content].bssid,
                                                  ap_name: apname,
                                                });
                                              }}
                                            >
                                              {/* <span className="icon-graph-line" />{" "} */}
                                              <strong>{parsedEssid || "<hidden>"}</strong>
                                            </div>
                                          </td>
                                        ) : null}

                                        <td className="border-right text-center">
                                          <div
                                          // onClick={(e) => {
                                          //   e.preventDefault();
                                          //   this.loadChartData({
                                          //     command: "bssid",
                                          //     from_ts: this.props.from_ts,
                                          //     to_ts: this.props.to_ts,
                                          //     essid: undefined,
                                          //     bssid: essid[content].bssid,
                                          //     ap_name: apname,
                                          //   });
                                          // }}
                                          >
                                            {essid[content].bssid}
                                          </div>
                                        </td>
                                        <td className="border-right text-center">
                                          {essid[content].freq + " MHz"}
                                        </td>
                                        <td className="border-right text-center">
                                          <span
                                            className="text-nowrap"
                                            id={
                                              "_tp_" +
                                              id +
                                              id2 +
                                              +id4 +
                                              id5 +
                                              id3 +
                                              "_" +
                                              essid[content].bssid.replace(/\W/g, "")
                                            }
                                          >
                                            <span
                                              className={classnames({
                                                "text-success":
                                                  parseInt("-" + essid[content].rssi) >=
                                                  -60,
                                                "text-orange":
                                                  parseInt("-" + essid[content].rssi) >=
                                                    -74 &&
                                                  parseInt("-" + essid[content].rssi) <
                                                    -60,
                                                "text-danger":
                                                  parseInt("-" + essid[content].rssi) <
                                                  -74,
                                              })}
                                            >
                                              {"-" + essid[content].rssi + " dBm"}
                                            </span>
                                            <ReactOTooltip
                                              placement="right"
                                              target={
                                                "_tp_" +
                                                id +
                                                id2 +
                                                +id4 +
                                                id5 +
                                                id3 +
                                                "_" +
                                                essid[content].bssid.replace(/\W/g, "")
                                              }
                                              text={
                                                <div className="text-left">
                                                  <div className="text-left">
                                                    RSSI: {essid[content].rssi + " dBm"}
                                                  </div>
                                                  <div className="text-left">
                                                    RSSI Max:{" "}
                                                    {essid[content].rssi_max + " dBm"}
                                                  </div>
                                                  <div className="text-left">
                                                    RSSI Min:{" "}
                                                    {essid[content].rssi_min + " dBm"}
                                                  </div>
                                                </div>
                                              }
                                            />
                                          </span>
                                        </td>
                                        <td className="border-right text-center">
                                          <span
                                            className="text-nowrap"
                                            id={
                                              "_tp_vis_" +
                                              id +
                                              id2 +
                                              +id4 +
                                              id5 +
                                              id3 +
                                              "_" +
                                              essid[content].bssid.replace(/\W/g, "")
                                            }
                                          >
                                            {essid[content].perc == "100.00"
                                              ? "100 %"
                                              : essid[content].perc + " %"}
                                            <ReactOTooltip
                                              placement="right"
                                              target={
                                                "_tp_vis_" +
                                                id +
                                                id2 +
                                                +id4 +
                                                id5 +
                                                id3 +
                                                "_" +
                                                essid[content].bssid.replace(/\W/g, "")
                                              }
                                              text={
                                                <div className="text-left">
                                                  <div className="text-left">
                                                    {" "}
                                                    Seen for {essid[content].views} out of{" "}
                                                    {this.props.totPres} minutes
                                                  </div>
                                                </div>
                                              }
                                            />
                                          </span>
                                        </td>
                                      </tr>
                                    );
                                  });
                                });
                              });
                            }
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <ReactOModal
            modalId="Chart"
            size="xl"
            onControllerReady={(modal_context) => {
              this._chart_modal = modal_context;
            }}
            header={(data) => {
              return (
                <div>
                  {this.state.essid} frequency chart{" "}
                  <span className="sub-title pl-2">
                    (related to AP {this.state.ap_name})
                  </span>
                </div>
              );
            }}
            body={(data) => {
              let freqObj = {
                "2GHz": {
                  visible: data.graphs[this.state.ap_name]["2GHz"] ? true : false,
                  name: "2 GHz",
                  domain: [0, Object.keys(this.props.wifi_data["2GHz"]).length],
                },
                "5GHz": {
                  visible: data.graphs[this.state.ap_name]["5GHz"] ? true : false,
                  name: "5 GHz",
                  domain: [0, Object.keys(this.props.wifi_data["5GHz"]).length],
                },
              };

              // ADD FIRST + LAST ITEM FOR CLOSE GRAPH
              let dataForChart = [...data.graphs[this.state.ap_name][this.state.freq]];
              let firstItem = { ...dataForChart[0] };
              let lastItem = { ...dataForChart[dataForChart.length - 1] };
              firstItem.time = this.props.from_ts;
              lastItem.time = this.props.to_ts + 10000000000;
              dataForChart.unshift(firstItem);
              dataForChart.push(lastItem);

              return (
                <div>
                  <div className="align-content-right">
                    {Object.keys(freqObj).map((freq, id) => {
                      return (
                        <ReactOButton
                          title={
                            freqObj[freq].visible == true
                              ? freqObj[freq].name
                              : "Not visible"
                          }
                          className={id % 2 == 0 ? "mr-2" : ""}
                          color={freqObj[freq].visible == true ? "primary" : "secondary"}
                          outline={
                            freqObj[freq].visible == false || freq != this.state.freq
                          }
                          size="sm"
                          key={id}
                          disabled={freqObj[freq].visible == false}
                          onClick={() => {
                            this.setState({ freq: freq });
                          }}
                        >
                          {freqObj[freq].name}
                        </ReactOButton>
                      );
                    })}
                  </div>
                  <ResponsiveContainer
                    aspect={this.props.aspectRatio || 2.0}
                    maxHeight={this.props.maxHeight || "auto"}
                  >
                    <ComposedChart
                      data={dataForChart}
                      // margin={{ top: 15, right: 0, bottom: 20, left: 0 }}
                    >
                      <YAxis
                        tickSize={10}
                        allowDataOverflow={true}
                        label={{
                          value: "Channel",
                          angle: -90,
                          position: "insideLeft",
                          fontSize: 12,
                          stroke: "#6E777F",
                          strokeWidth: 1,
                        }}
                        domain={freqObj[this.state.freq].domain}
                        dataKey="ord"
                        interval="preserveStartEnd"
                        scale="linear"
                        ticks={Object.keys(this.props.wifi_data[this.state.freq]).map(
                          (val, id) => {
                            let tick;
                            if (id != 0) {
                              tick = this.props.wifi_data[this.state.freq][val].ord;
                            }
                            return tick;
                          }
                        )}
                        tick={(props) => {
                          const { x, y, payload } = props;
                          return (
                            payload.value != undefined && (
                              <g transform={`translate(${x},${y})`}>
                                <text
                                  x={0}
                                  y={0}
                                  dy={4}
                                  textAnchor="end"
                                  fontSize={12}
                                  strokeWidth={1}
                                  stroke="#6E777F"
                                  // transform="rotate(-30)"
                                >
                                  {
                                    this.state.WIFIDATA[this.state.freq][payload.value]
                                      .lab
                                  }
                                </text>
                              </g>
                            )
                          );
                        }}
                      />
                      <XAxis
                        tickSize={10}
                        domain={[this.props.from_ts, this.props.to_ts]}
                        allowDataOverflow={true}
                        type="number"
                        dataKey="time"
                        // interval="preserveStartEnd"
                        scale="linear"
                        ticks={[
                          this.props.from_ts,
                          this.props.from_ts +
                            (this.props.to_ts - this.props.from_ts) / 3,
                          this.props.to_ts - (this.props.to_ts - this.props.from_ts) / 3,
                          this.props.to_ts,
                        ]}
                        // tickFormatter={(time) => {
                        //   return this.getAppContext()
                        //     .momentjs(time, "X")
                        //     .format("YYYY/MM/DD LT");
                        // }}
                        tick={(props) => {
                          const { x, y, payload } = props;
                          if (payload.value == this.props.from_ts) {
                            return (
                              <g transform={`translate(${x},${y})`}>
                                <text
                                  x={0}
                                  y={0}
                                  dy={16}
                                  textAnchor="start"
                                  fontSize={12}
                                  strokeWidth={1}
                                  stroke="#6E777F"
                                >
                                  {this.getAppContext()
                                    .momentjs(payload.value, "X")
                                    .format("YYYY/MM/DD LT")}
                                </text>
                              </g>
                            );
                          } else if (payload.value == this.props.to_ts) {
                            return (
                              <g transform={`translate(${payload.coordinate},${y})`}>
                                <text
                                  x={0}
                                  y={0}
                                  dy={16}
                                  textAnchor="end"
                                  fontSize={12}
                                  strokeWidth={1}
                                  stroke="#6E777F"
                                >
                                  {this.getAppContext()
                                    .momentjs(payload.value, "X")
                                    .format("YYYY/MM/DD LT")}
                                </text>
                              </g>
                            );
                          } else {
                            return (
                              <g transform={`translate(${x},${y})`}>
                                <text
                                  x={0}
                                  y={0}
                                  dy={16}
                                  textAnchor="middle"
                                  fontSize={12}
                                  strokeWidth={1}
                                  stroke="#6E777F"
                                >
                                  {this.getAppContext()
                                    .momentjs(payload.value, "X")
                                    .format("YYYY/MM/DD LT")}
                                </text>
                              </g>
                            );
                          }
                        }}
                      />
                      <Tooltip
                        isAnimationActive={false}
                        position={{ y: 15 }}
                        content={(props) => {
                          const { active, payload } = props;
                          if (active) {
                            let totalSeconds = payload[0].payload.length;
                            let hours = Math.floor(totalSeconds / 3600);
                            totalSeconds %= 3600;
                            let minutes = Math.floor(totalSeconds / 60);
                            let seconds = totalSeconds % 60;
                            return (
                              <div className="p-3 custom-tooltip rounded">
                                <div className="pb-2">
                                  {payload[0].payload.freq != "0"
                                    ? payload[0].payload.bssid
                                    : "ESSID not visible"}
                                </div>
                                <small className="text-tp-chart">
                                  <div className="d-flex">
                                    <div className="flex-grow-1">Start: </div>
                                    <div className="pl-3 text-right">
                                      {this.getAppContext()
                                        .momentjs(payload[0].payload.time, "X")
                                        .format("YYYY/MM/DD LT")}{" "}
                                      (for {hours != 0 ? hours + " h" : null}
                                      {minutes != 0 ? " " + minutes + " m" : null}
                                      {seconds != 0 ? " " + seconds + " s" : null})
                                    </div>
                                  </div>
                                  {payload[0].payload.freq == "0" ? (
                                    <div className="d-flex">
                                      <div className="flex-grow-1">Channel:</div>
                                      <div className="text-right">-</div>
                                    </div>
                                  ) : (
                                    <div className="d-flex">
                                      <div className="flex-grow-1">Channel:</div>
                                      <div className="text-right">
                                        {
                                          this.state.WIFIDATA[this.state.freq][
                                            payload[0].payload.ord
                                          ].lab
                                        }{" "}
                                        ({payload[0].payload.freq + " MHz"})
                                      </div>
                                    </div>
                                  )}

                                  <div className="d-flex">
                                    <div className="flex-grow-1">RSSI avg:</div>
                                    <div className="text-right">
                                      {payload[0].payload.rssi == "0"
                                        ? "-"
                                        : payload[0].payload.rssi}
                                    </div>
                                  </div>

                                  <div className="d-flex">
                                    <div className="flex-grow-1">RSSI min/max:</div>
                                    <div className="text-right">
                                      {payload[0].payload.rssi_max == "0"
                                        ? "-"
                                        : payload[0].payload.rssi_min +
                                          " / " +
                                          payload[0].payload.rssi_max}
                                    </div>
                                  </div>
                                </small>
                              </div>
                            );
                          }

                          return null;
                        }}
                      />
                      <Line
                        type="stepAfter"
                        dataKey="ord"
                        strokeWidth={2}
                        stroke="#337ab7"
                        isAnimationActive={false}
                      />
                      <Area
                        type="stepAfter"
                        dataKey="ord"
                        stroke="none"
                        fill="#337ab7"
                        strokeWidth={3}
                        strokeOpacity={1}
                        fillOpacity={0.3}
                        isAnimationActive={false}
                        dot={false}
                        activeDot={false}
                      />
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
              );
            }}
            actions={[
              {
                text: "Cancel",
                color: "light",
                action: "close",
              },
            ]}
          />
        </div>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(withRouter(ApCoverageTable), {
  define: null,
});
